import React from "react";
import { HIDE_COMPLIANCE_MARKS } from "../../config/env";
// import Text from "../../components/Text";
// import Messages from "../../Shared/Messages";

export default function SignupFooter() {
  return (
    <div className="d-flex align-items-center justify-content-between pb-2">
      <div>
        <img
          alt="myPatientSpace"
          src="/img/mps-logo.png"
          height={24}
        />
      </div>

      {!HIDE_COMPLIANCE_MARKS && (
        <div className="d-flex align-items-center">
          <img
            src="/img/ce-mark.png"
            height={18}
            alt="myPatientSpace - CE Mark"
            className="mr-3"
          />
          <img
            src="/img/mps-iso.png"
            height={18}
            alt="myPatientSpace - ISO"
          />
        </div>
      )}
    </div>
  );
}
